import { SessionStore } from '../../constants';
import { getStore } from '../../store';

export const isSimplifiedFlow = () => {
  const companySettings = getStore()?.state?.companySettings;
  const workflowSession = getStore()?.state?.workflowSession;
  const formStatusSession = sessionStorage.getItem(SessionStore.formStatus);
  const formStatus = formStatusSession && JSON.parse(formStatusSession);
  return companySettings.showSimplifiedForm && (!workflowSession.candidateRegistered || formStatus.surveyFormSubmitted);
};

export const isSimplifiedFormSubmited = () => {
  const companySettings = getStore()?.state?.companySettings;
  const formStatusSession = sessionStorage.getItem(SessionStore.formStatus);
  const formStatus = formStatusSession && JSON.parse(formStatusSession);

  if (isSimplifiedFlow()) {
    if (companySettings.showAppform) {
      return formStatus.appFormSubmitted && formStatus.surveyFormSubmitted;
    } else {
      return formStatus.surveyFormSubmitted;
    }
  }
  return false;
};
